import React from "react";
const IconSearchArrow = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16" {...props}>
    <path
      d="M4.844 12.239V4.79m0 0h7.448m-7.448 0 8.125 8.126"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
  </svg>
);
export default IconSearchArrow;
